<div *ngIf="!loading" class="animate-fade-in">
    <div class="product-list-controls__facet-list">
        <ul>
            <li
                class="product-list-controls__facet-item group"
                [class.active]="stockSelected"
                tabindex="0"
                (click)="stockSelected = !stockSelected; onFilterChange()"
                (keydown.enter)="stockSelected = !stockSelected; onFilterChange()"
                (keydown.space)="$event.preventDefault(); stockSelected = !stockSelected; onFilterChange()"
            >
                <label (mousedown)="$event.stopPropagation()">
                    <input
                        type="checkbox"
                        [(ngModel)]="stockSelected"
                        (change)="onFilterChange()"
                    />
                    <span class="product-list-controls__facet-item-text">In Stock</span>
                </label>
            </li>
            <li
                class="product-list-controls__facet-item group"
                [class.active]="preOrderSelected"
                tabindex="0"
                (click)="preOrderSelected = !preOrderSelected; onFilterChange()"
                (keydown.enter)="preOrderSelected = !preOrderSelected; onFilterChange()"
                (keydown.space)="$event.preventDefault(); preOrderSelected = !preOrderSelected; onFilterChange()"
            >
                <label (mousedown)="$event.stopPropagation()">
                    <input
                        type="checkbox"
                        [(ngModel)]="preOrderSelected"
                        (change)="onFilterChange()"
                    />
                    <span class="product-list-controls__facet-item-text">Pre-Order</span>
                </label>
            </li>
        </ul>
    </div>
</div>
